import React, { useState } from "react";
import { Loader2, BookOpen, User, CalendarDays, GraduationCap } from "lucide-react";

const Info = ({ icon: I, label, value, testid }) => (
  <div className="flex items-start gap-2 rounded-xl bg-white/10 px-3 py-2">
    <I className="w-4 h-4 text-[var(--gold)] mt-0.5 shrink-0" />
    <div><p className="text-[10px] font-extrabold tracking-wider text-white/60 uppercase">{label}</p><p data-testid={testid} className="text-sm font-bold text-white leading-tight">{value || "—"}</p></div>
  </div>
);

export const EvalInstructorForm = ({ item, preguntas, busy, onSubmit }) => {
  const [resp, setResp] = useState({});
  const set = (id, v) => setResp((p) => ({ ...p, [id]: v }));
  const faltan = preguntas.filter((q) => q.tipo === "escala" && !resp[q.id]).length;
  return (
    <div className="bg-white rounded-3xl ring-1 ring-black/5 overflow-hidden" data-testid="eval-inst-form">
      <div className="bg-gradient-to-br from-[#4A1F80] to-[#7B3FBF] p-5">
        <p className="text-xs font-extrabold tracking-[0.2em] text-[var(--gold)]">ENCUESTA DE TU CLASE</p>
        <div className="mt-3 grid sm:grid-cols-2 gap-2">
          <Info icon={GraduationCap} label="Clase" value={item.clase_titulo} testid="eval-form-clase" />
          <Info icon={BookOpen} label="Materia" value={item.materia_nombre} testid="eval-form-materia" />
          <Info icon={User} label="Instructor" value={item.instructor_nombre} testid="eval-form-instructor" />
          <Info icon={CalendarDays} label="Fecha" value={`${item.fecha || ""}${item.hora ? ` · ${item.hora}` : ""}`} testid="eval-form-fecha" />
        </div>
      </div>
      <div className="p-5 space-y-4">
        {preguntas.length === 0 && <p className="text-sm text-[#6B7688]">La coordinación aún no configuró las preguntas de esta encuesta.</p>}
        {preguntas.map((q, i) => (
          <div key={q.id}>
            <label className="block text-sm font-bold text-[#0A1C30] mb-2">{i + 1}. {q.label}</label>
            {q.tipo === "escala" ? (
              <div className="flex flex-wrap gap-2" data-testid={`eval-inst-q-${q.id}`}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <button key={n} type="button" data-testid={`eval-inst-q-${q.id}-${n}`} onClick={() => set(q.id, String(n))} className={`w-11 h-11 rounded-xl font-extrabold text-sm transition-colors ${resp[q.id] === String(n) ? "bg-[#7B3FBF] text-white" : "bg-[#F4F6F9] text-[#6B7688] hover:bg-[#EFEAFB]"}`}>{n}</button>
                ))}
              </div>
            ) : (
              <textarea data-testid={`eval-inst-q-${q.id}`} rows={3} value={resp[q.id] || ""} onChange={(e) => set(q.id, e.target.value)} className="w-full rounded-xl ring-1 ring-black/10 px-3 py-2 text-sm" placeholder="Escribe tu respuesta" />
            )}
          </div>
        ))}
        {preguntas.length > 0 && (
          <button data-testid="eval-inst-submit" onClick={() => onSubmit(resp)} disabled={busy || faltan > 0} className="w-full rounded-xl bg-[#7B3FBF] text-white font-extrabold py-3 disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {busy && <Loader2 className="w-4 h-4 animate-spin" />}{faltan > 0 ? `Responde las ${faltan} pregunta(s) de calificación` : "Enviar evaluación"}
          </button>
        )}
      </div>
    </div>
  );
};
